import { useMediaQuery } from 'react-responsive';

export const useIsLargeScreen = () => {
  return useMediaQuery({
    query: '(min-width: 1224px)',
  });
}
